import { useElapsed } from "../../utils/useElapsed";
import { useOverlayOrchestrator } from "./createOverlayOrchestratorContext";
/**
 * Mapping of overlay steps to their orchestration counterparts.
 * This is used to determine the next step in the overlay flow.
 */
const OVERLAY_STEP_ORCHESTRATION = {
    "custom-banner": { previousStep: "consent" },
    "adjust-banner": { previousStep: "custom-banner" },
    "google-one-tap": {
        previousStep: "custom-banner",
        interactions: { delay: 5 },
    },
    airship: { previousStep: "google-one-tap" },
};
export const useOverlayStepsOrchestrator = (key) => {
    const { state } = useOverlayOrchestrator();
    const { previousStep, interactions } = OVERLAY_STEP_ORCHESTRATION[key];
    const previousStepState = state[previousStep];
    const delay = interactions?.delay;
    const isElapsed = useElapsed({
        duration: delay ?? 0,
        active: previousStepState === "completed" && !!delay,
    });
    return (previousStepState === "disabled" ||
        (previousStepState === "completed" && (isElapsed || !delay)));
};
